const Wraper = (props) => props.children;
export default Wraper;
